<template>
  <div class="table-responsive ms-5 me-5">
    <table class="table">
      <tbody>
        <tr>
          <th>Material</th>
          <th>Especificación</th>
          <th>Presentación</th>
          <th>Especifación del espesor</th>
          <th>Precio</th>
        </tr>
        <tr v-for="sheet in sheets" :key="sheet.id">
          <td>{{ sheet.material }}</td>
          <td>{{ sheet.specification }}</td>
          <td>{{ sheet.presentation }}</td>
          <td>{{ sheet.scale }}</td>
          <td>{{ sheet.priceId["value"] }}</td>
          <td>
            <div>
              <!-- <input type="number" hidden v-bind:value="sheet.id"> -->
              <button class="btn btn-danger"
                v-on:click.prevent="viewSheetTypes(sheet.id, sheet.scale, sheet.presentation, sheet.specification)">
                Visualizar
              </button>
            </div>
          </td>
          <td>
            <button class="btn btn-danger" @click.prevent="editSheet(sheet.id)">
              Editar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      sheets: [],
      sheetTypes: [],
      showList: false,
    };
  },
  methods: {
    viewSheetTypes(sheetId, sheetScale, sheetPresentation, sheetSpecification) {
      this.$emit("sendMainSheetIdForTypes", { sheetId, sheetScale, sheetPresentation, sheetSpecification });
    },
    editSheet(sheetId) {
      // console.log(sheetId);
      this.$emit("sendMainSheetIdForEdit", sheetId);
    },
  },
  beforeMount() {
    axios
      .get(RUTA_SERVIDOR + "api/sheet/list", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.sheets = res.data))
      // .then((res)=>console.log(this.sheets))
      .catch((err) => console.log(`There has been an error ${err}`));
  },
};
</script>
<style scoped></style>